import { TableBlock, type TableBlockValue } from '../ds/TableBlock';

export type { TableCell, TableRow, TableBlockValue } from '../ds/TableBlock';

type BlogTableBlockProps = {
  value: TableBlockValue;
};

export function BlogTableBlock({ value }: BlogTableBlockProps) {
  return <TableBlock value={value} variant="blog" />;
}
